// colors.js
export const Colors = {
    textColor: 'black',
    // bgColor: 'linear-gradient(125deg, #D7EDE2, #014871)', // Apply gradient background
    bgColor: '#CAFFF9', // Apply gradient background
  };
  